export const enum TypeOptions {
    IntOption = 'IntOption',
    DropdownOption = 'DropdownOption',
    SliderOption = 'SliderOption',
    TickBoxOption = 'TickBoxOption',
    VectorOption = 'VectorOption',
    TextAreaOption = 'TextAreaOption',
}
